// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__OXaGI","footer":"ModalUpdate_footer__2JQva"};